<template>
    <reservations-card-grid-item
        :getDataEndpoint="getDataEndpoint"
        :tabWidget="tabWidget"
        :hideEnteredColumn="true"
        @success-tab-widget-settings-update="
            handleSuccessTabWidgetSettingsUpdate
        "
    />
</template>

<script>
import { DASHBOARD_BALANCES_DUE_RESERVATION_GRID_ENDPOINT } from '../../../../endpoints';
import ReservationsCardGridItem from '../common/reservations-card-grid-item.vue';

export default {
    name: 'BalancesDueReservationsTableCardGridItem',
    props: {
        tabWidget: Object,
    },
    components: {
        ReservationsCardGridItem,
    },
    methods: {
        handleSuccessTabWidgetSettingsUpdate() {
            this.$emit('success-tab-widget-settings-update', {
                id: this.tabWidget.id,
            });
        },
    },
    computed: {
        getDataEndpoint() {
            return DASHBOARD_BALANCES_DUE_RESERVATION_GRID_ENDPOINT();
        },
    },
};
</script>

